import { areObjectsEqual } from 'core/utils/object.utils';
import { OperatorCustomNotification } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { OperatorCustomNotificationWriteApi } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.api';
import {
    buildOperatorCustomNotificationPayload,
    mapComparableOperatorFormState,
    mapOperatorCustomNotificationToFormState,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.mapper';
import {
    ComparableOperatorCustomNotificationFormState,
    OperatorCustomNotificationFormState,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.model';

export const hasOperatorFormChanges = (
    form: OperatorCustomNotificationFormState,
    baseline: ComparableOperatorCustomNotificationFormState
): boolean => !areObjectsEqual(mapComparableOperatorFormState(form), baseline);

const toCountedPayload = ({ name: _name, ...counted }: OperatorCustomNotificationWriteApi) => counted;

export const hasCounterResettingChanges = (
    payload: OperatorCustomNotificationWriteApi,
    storedPayload: OperatorCustomNotificationWriteApi
): boolean => !areObjectsEqual(toCountedPayload(payload), toCountedPayload(storedPayload));

export const requiresCounterResetConfirmation = (
    payload: OperatorCustomNotificationWriteApi,
    notification: OperatorCustomNotification
): boolean =>
    hasCounterResettingChanges(
        payload,
        buildOperatorCustomNotificationPayload(
            mapOperatorCustomNotificationToFormState(notification),
            notification.trackedTriggers
        )
    );
